import "./Footer.css";

export const Footer = () => {
  return (
    <div className="Footer">
      <p>© 2026. All Rights Reserved to Joachim Wedin.</p>
    </div>
  )
}

